import { render } from "./GoogleRedirectView.vue?vue&type=template&id=158af377"
import script from "./GoogleRedirectView.vue?vue&type=script&lang=js"
export * from "./GoogleRedirectView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__